import 'regenerator-runtime/runtime';
import { call, put, takeEvery } from 'redux-saga/effects';
import { AnyAction } from 'redux';
import { GlobalActions, GlobalPut, HTTP_METHOD } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { Wechselgrund } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { CheckoutActions } from '../checkout.actions';

export const URL_VNWECHSELGRUND = '/privatschutz/api/vnwechselgrund';

export function* watchVnWechselgrundListRequest() {
  yield takeEvery(
    GlobalActions.AUTHENTICATION_SUCCESSFUL,
    safeSaga(getVnWechselgrundListSaga, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    CheckoutActions.VNWECHSELGRUND_REQUEST_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP_CHECKOUT),
  );
}

export function* getVnWechselgrundListSaga() {
  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequest({
      appId: App.SHOP_CHECKOUT,
      method: HTTP_METHOD.GET,
      body: '',
      url: URL_VNWECHSELGRUND,
      successEvent: CheckoutActions.VNWECHSELGRUND_REQUEST_SUCCESSFUL,
      errorEvent: CheckoutActions.VNWECHSELGRUND_REQUEST_FAILED,
    }),
  );
}

export function* successCallback(successAction: AnyAction) {
  const vnWechselgrundResponse: Wechselgrund[] = successAction.payload;
  yield put(new CheckoutActions().vnWechselgrundListReceived(vnWechselgrundResponse));
}
